<template>
  <BModal v-bind="$attrs" centered @ok.prevent="onOk" @hidden="onHide">
    <BInputGroup :prepend="currency">
      <BFormInput v-model="amount" type="number" min="0.00" />
    </BInputGroup>
  </BModal>
</template>

<script>
export default {
  name: 'CompanyPenaltyModal',

  props: {
    currency: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      amount: 0.0,
    }
  },

  methods: {
    onOk() {
      this.$emit('ok', { amount: this.amount })
    },
    onHide() {
      this.amount = 0.0
    },
  },
}
</script>
